<template>
    <div id="schedulepage">
        <schedule-table />
    </div>
</template>
<script>
import ScheduleTable from '../components/employees/ScheduleTable';
export default {
    components: { ScheduleTable },
};
</script>
